import { useMutation } from '@tanstack/react-query';
import { ALERT_STATUS, useAlert } from '../../../contexts/AlertContext';

import { sendLink } from '../../brandbooks';

const useSendLink = (handleSuccess) => {
	const { handleAlert } = useAlert();

	const { mutate: sendOutClientEmail, isPending } = useMutation({
		mutationFn: (data) => sendLink(data),
		onSuccess: handleSuccess,
		onError: (error) => {
			handleAlert(ALERT_STATUS.ERROR, error.response.data.error);
		},
	});

	return { sendOutClientEmail, isPending };
};

export default useSendLink;
